module.exports = __webpack_public_path__ + "img/hzico_4.fbd9081a.jpg";